import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'
import {
  DEFAULT_EXPANDED_MODULES,
  shellModules,
} from './navigation-config'

interface ShellState {
  collapsed: boolean
  isMobile: boolean
  mobileMenuOpen: boolean
  expandedModules: string[]
  setCollapsed: (collapsed: boolean) => void
  setMobileMenuOpen: (open: boolean) => void
  setExpandedModules: Dispatch<SetStateAction<string[]>>
  toggleModule: (moduleId: string) => void
}

export function useShellState(pathname: string): ShellState {
  const [collapsed, setCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [expandedModules, setExpandedModules] = useState<string[]>(DEFAULT_EXPANDED_MODULES)

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)

      if (window.innerWidth < 1024 && window.innerWidth >= 768) {
        setCollapsed(true)
      }

      if (!mobile) {
        setMobileMenuOpen(false)
      }
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  useEffect(() => {
    shellModules.forEach((module) => {
      if (!pathname.startsWith(module.href)) {
        return
      }

      setExpandedModules(prev => (prev.includes(module.id) ? prev : [...prev, module.id]))
    })
  }, [pathname])

  useEffect(() => {
    setMobileMenuOpen(false)
  }, [pathname])

  const toggleModule = (moduleId: string) => {
    setExpandedModules(prev =>
      prev.includes(moduleId)
        ? prev.filter(id => id !== moduleId)
        : [...prev, moduleId]
    )
  }

  return {
    collapsed,
    isMobile,
    mobileMenuOpen,
    expandedModules,
    setCollapsed,
    setMobileMenuOpen,
    setExpandedModules,
    toggleModule,
  }
}
